<template>
  <div class="ppv-date-range-section">
    <label class="ppv-section-label">{{ $t("ppv.older_visits.date_range_label") }}</label>

    <div class="ppv-input-group">
      <label class="ppv-sub-label">{{ $t("ppv.older_visits.start_date_label") }}</label>
      <div class="ppv-input-wrap">
        <input
          type="date"
          :value="startDate"
          :min="minStartDate"
          :max="maxStartDate"
          @input="updateStartDate($event.target.value)"
        >
      </div>
    </div>

    <div class="ppv-input-group">
      <label class="ppv-sub-label">{{ $t("ppv.older_visits.end_date_label") }}</label>
      <div class="ppv-input-wrap">
        <input
          type="date"
          :value="endDate"
          :min="startDate"
          :max="maxEndDate"
          @input="updateEndDate($event.target.value)"
        >
      </div>
    </div>

    <div v-if="error" class="ppv-date-error">
      <v-icon class="mr-1">{{ icons.mdiAlertCircleOutline }}</v-icon>
      {{ error }}
    </div>
  </div>
</template>

<script>
import icons from '@/mixins/icons'

export default {
  name: 'PpvDateRangeInput',
  mixins: [icons],
  props: {
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    maxStartDate: {
      type: String,
      default: null,
    },
    minStartDate: {
      type: String,
      default: null,
    },
    maxEndDate: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: '',
    },
  },
  emits: ['update:startDate', 'update:endDate'],
  methods: {
    updateStartDate(val) {
      this.$emit('update:startDate', val)
    },
    updateEndDate(val) {
      this.$emit('update:endDate', val)
    },
  },
}
</script>

<style scoped>
.ppv-section-label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 16px;
}
.ppv-input-group {
  margin-bottom: 20px;
}
.ppv-input-group label {
  display: block;
  margin-bottom: 6px;
}
.ppv-sub-label {
  font-size: 11px !important;
  color: #718096 !important;
  margin-bottom: 6px !important;
}
.ppv-input-wrap input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  color: #1a2340;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.ppv-input-wrap input:disabled {
  background: #f7fafc;
  cursor: not-allowed;
  opacity: 0.6;
}
.ppv-date-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0;
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 12px;
  color: #e53935;
  font-weight: 500;
}
.ppv-date-error .v-icon {
  color: #e53935 !important;
  font-size: 16px !important;
}
</style>
